"use client";

import { c as _c } from "react/compiler-runtime";
import { WaitlistSignup } from "@/components/email/waitlist";
import { Button } from "@/components/ui/button";
import { Icon } from "@/components/ui/icon";
import { cn } from "@/lib/utils";
import { motion } from "motion/react";
import Image from "next/image";
import { useState } from "react";
export const HeroSection = () => {
  const $ = _c(21);
  const [loaded, setLoaded] = useState(false);
  let t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      opacity: 0
    };
    t1 = {
      opacity: 1
    };
    t2 = {
      duration: 0.8
    };
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
  }
  const t3 = loaded ? "blur-none scale-100" : "blur-xl opacity-0 scale-110";
  let t4;
  if ($[3] !== t3) {
    t4 = cn("object-cover object-left z-[-1] mask-b-from-25% mask-b-to-90% opacity-75 transition-all duration-1000 delay-200 ease-out", t3);
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setLoaded(true);
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t4) {
    t6 = <Image src="/images/fs-img_02.jpg" alt="Death Matter" fill={true} className={t4} onLoad={t5} />;
    $[6] = t4;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  let t8;
  let t9;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      scale: 0.8,
      opacity: 0
    };
    t8 = {
      scale: 1,
      opacity: 1
    };
    t9 = {
      duration: 0.5
    };
    $[8] = t7;
    $[9] = t8;
    $[10] = t9;
  } else {
    t7 = $[8];
    t8 = $[9];
    t9 = $[10];
  }
  let t10;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <motion.div initial={t7} animate={t8} transition={t9} className="mb-0 lg:mb-8"><div className="size-32 md:size-48 bg-primary/10 rounded-full flex items-center justify-center mx-auto"><span className="text-4xl md:text-5xl font-bold text-primary">DM</span></div></motion.div>;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="flex flex-col lg:flex-row items-center justify-center gap-8">{t10}<motion.h1 className="text-4xl md:text-6xl lg:text-7xl font-bold tracking-tighter mb-6 uppercase font-sans" initial={{
        y: 20,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} transition={{
        delay: 0.2,
        duration: 0.5
      }}>Death Matter</motion.h1></div>;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <motion.p className="max-w-3xl text-base md:text-md text-accent-foreground/60 mb-16 text-balance tracking-wider" initial={{
      y: 20,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} transition={{
      delay: 0.4,
      duration: 0.5
    }}>Death Matter combines compassion, experience in the grieving process, and advanced technology to help people prepare and work through the administrative burden that accompanies death in our current time. When you use Death Matter tools, you transform a difficult experience into one that's more manageable and meaningful.</motion.p>;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  let t13;
  let t14;
  let t15;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      y: 20,
      opacity: 0
    };
    t14 = {
      y: 0,
      opacity: 1
    };
    t15 = {
      delay: 0.6,
      duration: 0.5
    };
    $[14] = t13;
    $[15] = t14;
    $[16] = t15;
  } else {
    t13 = $[14];
    t14 = $[15];
    t15 = $[16];
  }
  let t16;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <WaitlistSignup />;
    $[17] = t16;
  } else {
    t16 = $[17];
  }
  let t17;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <div className="flex flex-col items-center justify-center mb-20">{t12}<motion.div initial={t13} animate={t14} transition={t15} className="flex items-center gap-4">{t16}<Button size="lg" variant="ghost" className="text-base md:text-lg md:px-12 md:py-8"><a href="#obituary-writer" className="flex items-center gap-2">Learn More<motion.span initial={{
              y: -40,
              opacity: 0
            }} animate={{
              y: 0,
              opacity: 1
            }} transition={{
              delay: 1.25,
              duration: 0.25
            }}><Icon icon="carbon:arrow-down" className="size-8 mt-2 text-muted-foreground/50 animate-bounce" /></motion.span></a></Button></motion.div></div>;
    $[18] = t17;
  } else {
    t17 = $[18];
  }
  let t18;
  if ($[19] !== t6) {
    t18 = <motion.section className="min-h-screen flex flex-col items-center justify-end px-4 md:px-6 py-12 text-center relative z-10" initial={t0} animate={t1} transition={t2}>{t6}{t11}{t17}</motion.section>;
    $[19] = t6;
    $[20] = t18;
  } else {
    t18 = $[20];
  }
  return t18;
};